import React from "react";
import PinkButton from "../../molecules/PinkButton";
import loremText from "../../assets/images/loremText.svg";

import ImageDemo from "../../assets/images/landingImg.svg";
// import ImageDemo from "../../assets/images/circuit_board.png";

const Banner = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-7 gap-0 mx-4 md:mx-8 mt-4 md:mt-12">
      <div className=" md:hidden col-span-3 m-5 md:-m-5 place-self-center ">
        <div>
          <img src={ImageDemo} alt="langing section" />
        </div>
      </div>

      {/* Left Section */}
      <div className="col-span-4">
        {/* //Heading// */}
        <div className="text-red/80 text-2xl md:text-5xl">
          lorem ipsum dolor sit amet, consectetur adipiscing elit,
        </div>
        {/* //SUBTITLE// */}
        <div className="text-grey text-lg  md:text-xl md:w-3/4 my-6 md:my-14">
          lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. ut enim ad
          minim veniam,
        </div>
        <div>
          <img src={loremText} alt="Lorem Play" />
        </div>
        <div className="w-1/2 md:w-1/3 mt-6 md:mt-12 ">
          <PinkButton text="so, how it works ?" />
        </div>
      </div>

      {/* RIGTH SECTION */}
      <div className="hidden md:block col-span-3 md:-m-5 place-self-center">
        <div>
          <img src={ImageDemo} alt="video section" />
        </div>
      </div>
    </div>
  );
};

export default Banner;
